import { render, staticRenderFns } from "./RoleManagementEdit.vue?vue&type=template&id=011f6890&scoped=true&"
import script from "./RoleManagementEdit.vue?vue&type=script&lang=js&"
export * from "./RoleManagementEdit.vue?vue&type=script&lang=js&"
import style0 from "./RoleManagementEdit.vue?vue&type=style&index=0&id=011f6890&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "011f6890",
  null
  
)

export default component.exports